/*** IMPORTS FROM imports-loader ***/
var shim = require("es5-shim/es5-shim");
var sham = require("es5-shim/es5-sham");

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var config = require('../config');

var newCmtCodeMap = {
    1000: [100, '发送成功'],
    4920: [101, '管理员关闭聊天功能'],
    4923: [102, '该用户被禁言'],
    4921: [104, '不允许匿名聊天'],
    4915: [105, '聊天消息长度错误'],
    4906: [106, '频繁发送'],
    4907: [107, '发送聊天内容中包含敏感词'],
    4935: [135, '系统不允许观众使用匿名身份'],
    4936: [136, '昵称中包含敏感词'],
    103: [103, '其他错误，发送失败']
};

var defaultAnonymousCommentConfig = {
    allowed: false,
    inUse: false,
    nickname: '匿名观众',
    avatar: 'https://static.mudu.tv/assets/anonymized-user-avatar.png'
};

var Comment = function () {
    function Comment(_ref) {
        var _this = this;

        var jsonObj = _ref.jsonObj,
            Room = _ref.Room;
        (0, _classCallCheck3["default"])(this, Comment);

        this.act_id = jsonObj.act.id;
        this.actHashId = jsonObj.actHashId;

        this.Room = Room;

        // 聊天匿名身份配置
        this.anonymousCommentConfig = defaultAnonymousCommentConfig;

        this.initComment();

        this._msgbusDestroy();

        _scope.MsgBus.OnMultiOnce(['Comment.GetConfig.Over', 'Comment.GetCount.Over'], function () {
            _this.initCommentOver();
        });
    }

    (0, _createClass3["default"])(Comment, [{
        key: 'initComment',
        value: function initComment() {
            var _self = this,
                initConfUrl = config.API_DOMAIN + '/comments/api/activities/' + this.actHashId + '/config',
                initCmtCountUrl = config.API_DOMAIN + '/comments/api/activities/' + this.actHashId + '/comments/count?reviewed=1';

            var requestHeaders = _scope.DB.Get('requestHeader');

            // 获取评论的初始化配置
            Fetcher.Get(initConfUrl, function (res) {
                try {
                    res = JSON.parse(res);
                    if (res.errcode === 1000) {
                        var data = res.data;
                        _self.allow_publish = data["public"];
                        _self.allow_anonymous = data.allow_anonymous;
                        _self.needs_check = data.comment_review;
                        _self.auto_push = !data.danmu_review;
                        _self.anonymous_users_enabled = data.anonymous_users_enabled;
                        _self.anonymousCommentConfig.allowed = data.anonymous_users_enabled;
                    } else {
                        throw new Error(res.errcode);
                    }

                    _scope.MsgBus.Pub('Comment.GetConfig.Over');
                } catch (err) {
                    _scope.MsgBus.Pub('Comment.Init.Over');
                    _scope.MsgBus.Pub('Comment.Init.Error', err);
                    _scope.MsgBus.Pub('Room.Init.Error', err);
                }
            }, (0, _extends3["default"])({ 'Content-Type': 'application/json' }, requestHeaders.token));

            // 获取初始化时的评论条数
            Fetcher.Get(initCmtCountUrl, function (res) {
                try {
                    var data = JSON.parse(res);
                    if (data.errcode === 1000) {
                        _self.SetCount(data.total);
                    } else {
                        throw new Error(data.errcode);
                    }

                    _scope.MsgBus.Pub('Comment.GetCount.Over');
                } catch (err) {
                    _scope.MsgBus.Pub('Comment.Init.Over');
                    _scope.MsgBus.Pub('Comment.Init.Error', err);
                    _scope.MsgBus.Pub('Room.Init.Error', err);
                }
            }, (0, _extends3["default"])({ 'Content-Type': 'application/json' }, requestHeaders.token));
        }
    }, {
        key: 'initCommentOver',
        value: function initCommentOver() {
            this._ropOnVisitorMute();
            this._ropMsg();
            _scope.MsgBus.Pub('Comment.Init.Over');
        }
    }, {
        key: '_msgbusDestroy',
        value: function _msgbusDestroy() {
            var _this2 = this;

            this.destroyKey = _scope.MsgBus.On('Destroy', function () {
                _scope.MsgBus.UnSubAll('User.Mute');
                _scope.MsgBus.UnSubAll('Comment.Top');
                _scope.MsgBus.UnSubAll('Comment.New');
                _scope.MsgBus.UnSubAll('Comment.Delete');
                _scope.MsgBus.UnSubAll('Comment.AllowPublish');
                _scope.MsgBus.UnSubAll('Barrage.New');
                _scope.MsgBus.UnSub('Destroy', _this2.destroyKey);
                _this2.UnSubCommentsTopic();
            });
        }
    }, {
        key: 'UnSubCommentsTopic',
        value: function UnSubCommentsTopic() {
            this.unsubAct && this.unsubAct();
            this.unsubComment && this.unsubComment();
        }
    }, {
        key: '_ropMsg',
        value: function _ropMsg() {
            var _this3 = this;

            this.unsubComment = nats.on('mudu.comments.' + this.actHashId, function (msg) {
                var data = JSON.parse(msg);
                if (data.action) {
                    // comment新标准：有action的格式
                    _this3._parseMsgWithAction(data);
                } else if (data.type) {
                    _this3._parseMsgWithType(data);
                }
            });
        }
    }, {
        key: '_parseMsgWithAction',
        value: function _parseMsgWithAction(data) {
            var actions = data.action.split(',');
            if (!actions) {
                return;
            }
            var res = data.content;
            // 弹幕
            if (actions.indexOf('danmu') !== -1) {
                // 弹幕过滤掉大表情
                if (!this.hasNewEmotion(res.message)) {
                    this._updateDealDanmu(data);
                }
            }
            // 高亮弹幕
            if (actions.indexOf('highlight') !== -1) {
                this._updateDealDanmu(data, true);
            }
            // 聊天消息
            if (actions.indexOf('comment') !== -1) {
                // 是聊天消息且审核没有通过
                if (res && (res.msg_type === 10 || res.msg_type === 11) && res.priority === 0) return;
                this._updateNewCmt(res);
            }
        }
    }, {
        key: '_parseMsgWithType',
        value: function _parseMsgWithType(res) {
            var data = res.data,
                type = res.type;

            switch (type) {
                case 'config':
                    // 配置升级
                    this._updateConfig(data);
                    break;
                case 'top': // 新置顶
                case 'canceltop':
                    // 新置顶
                    this._updateNewTop(data);
                    break;
                case 'top_new':
                    this._updateNewCmt(data);
                    this._updateNewTop(data);
                    break;
                case 'delete':
                    this._handleDelete(data);
                    break;
                case 'reply':
                    this._updateNewReply(data);
                    break;
                case 'deletereply':
                    this._handleDeleteReply(data);
                    break;
                default:
                    break;
            }
        }

        /**
         * 检查是否有新大表情
         */

    }, {
        key: 'hasNewEmotion',
        value: function hasNewEmotion(str) {
            // 新GIF表情
            var emNewGifReg = new RegExp(/\[em_new_gif_([^]+)\]/g);
            // 新png表情
            var emNewPngReg = new RegExp(/\[em_new_png_([^]+)\]/g);
            return emNewGifReg.test(str) || emNewPngReg.test(str);
        }
    }, {
        key: '_ropOnVisitorMute',
        value: function _ropOnVisitorMute() {
            this.unsubAct = nats.on('mudu.activities.' + this.actHashId, function (data) {
                data = JSON.parse(data);
                var type = data.type;
                if (type === 'ban' || type === 'remban') {
                    data = data.data;
                    var _data = {};
                    _data.visitorId = data.user_id;
                    _data.isSelf = data.user_id == _scope.DB.Get('UserInfo').hash_id;
                    _data.user = data.username;
                    _data.mute = type === 'ban';
                    _scope.MsgBus.Pub('User.Mute', _data);
                }
            });
        }
    }, {
        key: '_resolveMsg',
        value: function _resolveMsg(msg, msg_type) {

            if (50 === msg_type) {
                // 图片
                msg = '<div class="comment-img"><img src="' + msg + '" /></div>';
            } else if (42 === msg_type) {
                // 现金打赏
                var amount = JSON.parse(msg).amount;
                msg = '<span style="color: red">打赏 ' + amount + '元</span>';
            } else if (41 === msg_type || 40 === msg_type) {
                // 道具打赏
                var obj = JSON.parse(msg),
                    src = obj.src,
                    number = obj.number;
                msg = "<span style='color: red'>送出 <img class='gift_img' style='width: 2rem;height: 2rem;vertical-align: middle;' src='" + src + "'/> 发生的，数量 " + number + "</span>"; // eslint-disable-line
            } else if (22 === msg_type) {
                // 竞答红包
                var _obj = JSON.parse(msg),
                    hashId = _obj.id;
                msg = '<div data-id="' + hashId + '" data-name="参与竞答领取红包！" class="rop-qa-redpack"><img src="https://static.mudu.tv/assets/redpack/qa-envelope.png"/><p>参与竞答领取红包！</p><span>点击答题</span></div>';
            } else if (21 === msg_type) {
                // 口令红包
                var _obj2 = JSON.parse(msg),
                    _hashId = _obj2.id,
                    name = _obj2.name,
                    type = _obj2.type;
                msg = '<div data-id="' + _hashId + '" data-name="官方" data-type="' + type + '" class="rop-word-redpack"><img src="//mudu.tv/assets/img/console/envelope.png"/><p>' + name + '</p></div>';
            } else if (20 === msg_type) {
                // 普通红包
                var _obj3 = JSON.parse(msg),
                    _hashId2 = _obj3.id,
                    _name = _obj3.name,
                    _type = _obj3.type;
                msg = '<div data-id="' + _hashId2 + '" data-type="' + _type + '" data-name="官方" data-wishes="' + _name + '" class="envelope-rop-wrap"><img src="//mudu.tv/assets/img/console/envelope.png"/><p>' + _name + '</p><span>查看红包</span></div>';
            }

            return msg;
        }
    }, {
        key: '_resolveCmt',
        value: function _resolveCmt(cmt) {
            var ret = (0, _extends3["default"])({}, cmt);
            try {
                var dateline = ret.dateline;
                if ('string' === typeof dateline) {
                    ret.dateline = parseInt(new Date(dateline).getTime() / 1000);
                }
            } catch (e) {/** */}
            var res = {
                id: ret.id,
                visitor_id: ret.user_id,
                username: ret.username,
                title: ret.title,
                is_admin: ret.is_admin ? 1 : 0,
                dateline: ret.dateline,
                checked: ret.priority !== 0 ? 1 : 0,
                pushed: ret.is_pushed ? 1 : 0,
                avatar: ret.avatar === '/assets/img/avatar.png' ? 'https://static.mudu.tv/index/avatar.png' : ret.avatar,
                top: ret.priority >= 100 ? 1 : 0,
                // origin_msg: ret.message,
                priority: ret.priority,
                message: ret.message,
                msg_type: ret.msg_type,
                reply_count: ret.reply_count || 0,
                replies: ret.replys || [],
                replys: ret.replys || []
            }; //msg_type = ret.msg_type, msg = ret.message;

            // 表情图片替换成文字
            // ret.message = ret.message.replace(config.COMMENT_IMAGE_NUM_REG, (str, p1) => {
            //     return p1 ? `[em_${p1}]` : str;
            // });

            // res.message = this._resolveMsg(msg, msg_type);
            return res;
        }
    }, {
        key: 'GetAllowPublish',
        value: function GetAllowPublish() {
            return this.allow_publish;
        }
    }, {
        key: 'GetNeedsCheck',
        value: function GetNeedsCheck() {
            return this.needs_check;
        }
    }, {
        key: 'GetAllowAnonymous',
        value: function GetAllowAnonymous() {
            return this.allow_anonymous;
        }
    }, {
        key: 'GetAutoPush',
        value: function GetAutoPush() {
            return this.auto_push;
        }

        //发送评论接口

    }, {
        key: 'Send',
        value: function Send(msg, cb) {
            var _self = this;
            var url = config.API_DOMAIN + '/comments/api/activities/' + this.actHashId + '/comment';
            var param = {
                message: msg
            };
            if (this.anonymousCommentConfig.allowed && this.anonymousCommentConfig.inUse) {
                param.avatar = this.anonymousCommentConfig.avatar || defaultAnonymousCommentConfig.avatar;
                param.msg_type = 11;
                param.username = this.anonymousCommentConfig.nickname || defaultAnonymousCommentConfig.nickname;
            }
            var requestHeaders = _scope.DB.Get('requestHeader');
            var callback = function callback(data) {
                data = JSON.parse(data);
                var cbData = {};
                cbData.status = data.errcode === 1000 ? 'y' : 'n';
                var infoArr = newCmtCodeMap[data.errcode] || [103, '发送失败!'];
                cbData.flag = infoArr[0];
                cbData.info = infoArr[1];
                cbData.hasBadWord = data.errcode === 4907;
                typeof cb === 'function' && cb((0, _stringify2["default"])(cbData));

                // cmt tracker
                var tracker = _self.Room.tracker;
                if (tracker && 'function' === typeof tracker.triggerEvent) {
                    tracker.triggerEvent({
                        category: 'interact',
                        action: 'comment',
                        label: msg
                    });
                }
            };
            Fetcher.Post(url, (0, _stringify2["default"])(param), callback, (0, _extends3["default"])({ 'Content-Type': 'application/json' }, requestHeaders.token, requestHeaders.session));
        }

        //获取评论接口，dataId如果为0则获取最新一页

    }, {
        key: 'Get',
        value: function Get() {
            var dataId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var cb = arguments[1];

            var self = this;

            if (dataId > this.page || dataId < 0 || typeof dataId !== 'number') {
                console.warn('page index err'); // eslint-disable-line
                return;
            } else if (dataId == 0) {
                dataId = this.page;
            }

            var requestHeaders = _scope.DB.Get('requestHeader');

            var url = config.API_DOMAIN + '/comments/api/activities/' + this.actHashId + '/comments?page_index=' + dataId;

            var callback = function callback(res) {
                res = JSON.parse(res);
                var data = res.data;
                var cbData = {};
                if (res.errcode === 1000) {
                    cbData = {
                        status: 'y',
                        info: '评论获取成功',
                        data: {
                            page: +dataId,
                            comments: data.map(function (v) {
                                return self._resolveCmt(v);
                            })
                        }
                    };
                } else {
                    cbData = {
                        status: 'n',
                        info: '没有更多评论！',
                        data: {
                            comments: []
                        }
                    };
                }

                typeof cb === 'function' && cb((0, _stringify2["default"])(cbData));
            };
            Fetcher.Get(url, callback, requestHeaders.token);
        }
    }, {
        key: 'SetCount',
        value: function SetCount(count) {
            this.count = count;
            this.page = Math.ceil(count / 20);
        }
    }, {
        key: 'GetPage',
        value: function GetPage() {
            return this.page;
        }
    }, {
        key: 'GetAnonymousCommentConfig',
        value: function GetAnonymousCommentConfig() {
            return this.anonymousCommentConfig;
        }

        // 设置匿名配置

    }, {
        key: 'SetAnonymousCommentConfig',
        value: function SetAnonymousCommentConfig(param, cb) {
            var _this4 = this;

            var newConfig = (0, _extends3["default"])({}, this.anonymousCommentConfig, param);
            var callbackFunc = function callbackFunc(result, cb) {
                try {
                    if (typeof cb === 'function') {
                        cb(result);
                    }
                } catch (error) {
                    console.error();
                }
            };

            if (newConfig.nickname.length > 60) {
                callbackFunc((0, _stringify2["default"])({
                    status: 'n',
                    errcode: 1406
                }), cb);
                return;
            } else if (!this.anonymous_users_enabled) {
                callbackFunc((0, _stringify2["default"])({
                    status: 'n',
                    errcode: 4935
                }), cb);
                return;
            }

            this._checkSensitiveWords(newConfig.nickname, function (checkResult) {
                if (checkResult.sensitive) {
                    callbackFunc((0, _stringify2["default"])({
                        status: 'n',
                        errcode: 4936
                    }), cb);
                } else {
                    _this4.anonymousCommentConfig = newConfig;
                    callbackFunc((0, _stringify2["default"])({
                        status: 'y',
                        errcode: 1000
                    }), cb);
                }
            });
        }

        // 检查敏感词

    }, {
        key: '_checkSensitiveWords',
        value: function _checkSensitiveWords(string, callback) {
            var requestHeaders = _scope.DB.Get('requestHeader');
            Fetcher.Post(
            // url
            config.API_DOMAIN + '/senswords/api/users/' + this.Room.uin + '/nick/sensword',
            // 请求参数
            (0, _stringify2["default"])({ word: string }),
            // 回调
            function (result) {
                var res = JSON.parse(result);
                callback(res);
            },
            // header
            (0, _extends3["default"])({ 'Content-Type': 'application/json' }, requestHeaders.token));
        }
    }, {
        key: '_updateConfig',
        value: function _updateConfig(data) {
            var allow_anonymous = data.allow_anonymous,
                comment_review = data.comment_review,
                danmu_review = data.danmu_review;

            this.allow_anonymous = allow_anonymous;
            this.needs_check = comment_review;
            this.auto_push = !danmu_review;
            // const last_allow_publish = this.allow_publish;
            this.allow_publish = data["public"];
            this.anonymous_users_enabled = data.anonymous_users_enabled;
            this.anonymousCommentConfig.allowed = data.anonymous_users_enabled;
            _scope.MsgBus.Pub('Comment.config', data);
        }
    }, {
        key: '_updateDealDanmu',
        value: function _updateDealDanmu(data) {
            var highlight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var content = data.content;

            var res = {
                visitor_id: content.user_id,
                text: content.message,
                msg_type: content.msg_type,
                stime: new Date().getTime(),
                high: highlight ? '1' : '0'
            };
            _scope.MsgBus.Pub('Barrage.New', (0, _stringify2["default"])(res));
        }
    }, {
        key: '_updateNewCmt',
        value: function _updateNewCmt(data) {
            var newCmt = this._resolveCmt(data);
            _scope.MsgBus.Pub('Comment.New', (0, _stringify2["default"])(newCmt));
        }
    }, {
        key: '_updateNewTop',
        value: function _updateNewTop(data) {
            var newCmt = this._resolveCmt(data);
            _scope.MsgBus.Pub('Comment.Top', (0, _stringify2["default"])(newCmt));
        }
    }, {
        key: '_handleDelete',
        value: function _handleDelete(data) {
            var newCmt = this._resolveCmt(data);
            _scope.MsgBus.Pub('Comment.Delete', (0, _stringify2["default"])(newCmt));
        }
    }, {
        key: '_updateNewReply',
        value: function _updateNewReply(data) {
            _scope.MsgBus.Pub('Comment.Reply.New', (0, _stringify2["default"])(data));
        }
    }, {
        key: '_handleDeleteReply',
        value: function _handleDeleteReply(data) {
            _scope.MsgBus.Pub('Comment.Reply.Delete', (0, _stringify2["default"])(data));
        }
    }]);
    return Comment;
}();

module.exports = Comment;



/*****************
 ** WEBPACK FOOTER
 ** ./~/es3ify-loader!./~/imports-loader?shim=es5-shim/es5-shim&sham=es5-shim/es5-sham!./~/babel-loader/lib!./application/components/core/Comment.js
 ** module id = 166
 ** module chunks = 1
 **/